export const DASHBOARD_SUBMISSION_CARDS_PAGE_SIZE = 20;

export const MAX_PAGE_SIZE = 500;
